import { styled } from "@mui/material";

export const ReportOption = styled("li")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  padding: 15,
}));

export const ReportOptionText = styled("span")(() => ({
  color: "#475467",
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.5px",
}));
